// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "js/" + "about" + "-legacy." + "6aaa4484" + ".js"; };